import './lib/legacy-storage.ts';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { router } from './App.tsx';
import { startData } from './lib/data.ts';
import { isMockRequested } from './lib/mock.ts';
import { registerPwa } from './features/mobile/pwa.ts';
import { primeServer } from './features/server/server.ts';
import './styles/index.css';

primeServer();
startData();
registerPwa({ mock: isMockRequested() });

const root = document.getElementById('root');
if (!root) throw new Error('The page is missing its #root element.');
createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
